import { Menu as MenuIcon } from '@mui/icons-material';
import { AppBar, Box, IconButton, Toolbar } from '@mui/material';
import { styled } from '@mui/material/styles';
import { UserWidget } from 'features/auth';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TenantLogoMark } from 'shared/components';

import { useNavigationContext } from '../../../contexts/NavigationContext';
import AppTitle from '../AppTitle';
import Spacer from '../Spacer';
import DetailPageHeader from './DetailPageHeader';
import MobileNavigationSidePanel from './MobileNavigationSidePanel';

export default function NavigationMobile() {
    const navigate = useNavigate();
    const [ menuOpen, setMenuOpen ] = useState(false);
    const { mobileHeaderOverride } = useNavigationContext();

    const toggleNav = () => setMenuOpen(x => !x);

    const onSelect = (path: string) => {
        navigate(path);
        setMenuOpen(false);
    };

    if (mobileHeaderOverride) {
        return <DetailPageHeader config={ mobileHeaderOverride } />;
    }

    return (
        <>
            <AppBar position="fixed"
                color="default">
                <HeaderContent>
                    <MobileMenuButton onClick={ toggleNav }
                        aria-label="menu"
                        aria-expanded={ menuOpen }
                    >
                        <MenuIcon />
                    </MobileMenuButton>

                    <LogoSection>
                        <TenantLogoMark />
                        <AppTitle />
                    </LogoSection>

                    <Box>
                        <UserWidget />
                    </Box>
                </HeaderContent>
            </AppBar>

            <MobileNavigationSidePanel open={ menuOpen }
                toggleNav={ toggleNav }
                onSelect={ onSelect }
            />

            <Spacer />
        </>
    );
}

const HeaderContent = styled(Toolbar)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(0, 2)
}));

const LogoSection = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5)
}));

const MobileMenuButton = styled(IconButton)(({ theme }) => ({
    color: theme.palette.text.primary,
  
    [theme.breakpoints.up('sm')]: {
        display: 'none'
    }
}));
